var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUralsib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8107 0C21.3434 0 21.91 0.0220648 22.5372 0.0724987V3.9102C22.5372 20.8197 23.1819 28.1295 25.6815 39.4015C22.4876 40.2005 19.0999 40.2005 15.9115 39.3952C18.4277 28.0413 19.077 20.7315 19.077 3.9102V0.0724987C19.7106 0.0220648 20.2772 0 20.8107 0ZM40.1087 21.4313C40.1087 14.8544 36.5263 9.0718 31.1441 5.77783L31.2166 10.2428C34.416 12.993 36.4428 16.9931 36.4428 21.4313C36.4428 23.4581 36.0094 25.3919 35.249 27.1587C32.9329 24.9585 31.2828 22.3706 30.256 19.3146C29.0172 15.6156 28.728 11.5651 28.6839 6.6163L28.6894 4.48862L28.2355 4.29949L27.8194 4.13873C26.9778 3.82352 26.111 3.56347 25.2292 3.36646L25.2347 6.60999C25.3513 23.6976 28.3119 30.741 32.7162 36.035C37.2206 32.6355 40.1087 27.3588 40.1087 21.4313ZM16.3796 6.61315L16.3851 3.36962C15.1967 3.63597 14.036 4.01422 12.9249 4.49177L12.9304 6.61945C12.8807 11.5635 12.597 15.6187 11.3583 19.3178C10.337 22.3737 8.68132 24.9569 6.3653 27.1618C5.60485 25.395 5.17143 23.4612 5.17143 21.4344C5.17143 16.9899 7.19273 12.9962 10.3976 10.246L10.4701 5.78099C5.08238 9.06865 1.5 14.8512 1.5 21.4344C1.5 27.362 4.39365 32.6386 8.89251 36.0382C13.3078 30.7505 16.2629 23.7008 16.3796 6.61315Z",
    fill: "#3B175C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUralsib);
export default __webpack_public_path__ + "static/media/uralsib.6788678e55d99a5b7505100e2d99d2cf.svg";
export { ForwardRef as ReactComponent };